import {
  ProductApplications,
  TaxonomyWithKey,
  TaxonomyWithKeyMultiselect,
} from '../../types';

export const isSingleApplication = (
  app: TaxonomyWithKey | TaxonomyWithKeyMultiselect,
): app is TaxonomyWithKey => (app as TaxonomyWithKey).data !== undefined;

export const convertApplicationsToString = (
  applications: ProductApplications,
  otherValue: string | null = '',
): string =>
  applications
    .map((app) => (isSingleApplication(app) ? [app] : Object.values(app)))
    .map((app) =>
      app
        .map(
          ({ data = '', key }) =>
            data + (key === 'other' ? ` (${otherValue})` : ''),
        )
        .join(', '),
    )
    .join(' / ');

export const displayIdFromId = (id: string): string =>
  `elab-${id.substr(0, 4).toLowerCase()}-${id.substr(4, 4).toLowerCase()}`;
